import type { DashboardScoreModuleEntity } from '@/core/infrastructure/schemas/dashboard/DashboardScoreModuleSchema'
import { DashboardScoreModuleSchema } from '@/core/infrastructure/schemas/dashboard/DashboardScoreModuleSchema'
import { DashboardScoreModuleGrain } from '@/core/domain/dashboard/DashboardScoreModuleGrain'
import { EvaluationRange } from '@/core/domain/resources/enums/EvaluationRange.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

export class DashboardScoreModule {
  readonly identifier: string
  readonly firstname: string
  readonly lastname: string
  readonly teacherFirstname: string | null
  readonly teacherLastname: string | null
  readonly taskId: number
  readonly taskTitle: string
  readonly taskOrder: number
  readonly diagScorePercentRounded: number | null
  readonly diagQuizVersionNumber: number | null
  readonly diagEvalRangeName: EvaluationRange.Values | null
  readonly moduleScorePercentRounded: number | null
  readonly moduleEvalRangeName: EvaluationRange.Values | null
  readonly diagnosticModuleVariation: number | null
  readonly learningGrains: DashboardScoreModuleGrain[]

  constructor(DashboardModule: DashboardScoreModuleEntity) {
    this.identifier = DashboardModule.identifier
    this.firstname = DashboardModule.firstname
    this.lastname = DashboardModule.lastname
    this.teacherFirstname = DashboardModule.teacherFirstname
    this.teacherLastname = DashboardModule.teacherLastname
    this.taskId = DashboardModule.taskId
    this.taskTitle = DashboardModule.taskTitle
    this.taskOrder = DashboardModule.taskOrder
    this.diagScorePercentRounded = DashboardModule.diagScorePercentRounded
    this.diagQuizVersionNumber = DashboardModule.diagVersionNumber
    this.diagEvalRangeName = DashboardModule.diagEvalRangeName
    this.moduleScorePercentRounded = DashboardModule.moduleScorePercentRounded
    this.moduleEvalRangeName = DashboardModule.moduleEvalRangeName
    this.diagnosticModuleVariation = DashboardModule.diagnosticModuleVariation
    this.learningGrains = DashboardModule.learningGrains.map((grain) => {
      return DashboardScoreModuleGrain.create(grain)
    })
  }

  get teacherFullname() {
    return `${this.teacherFirstname} ${this.teacherLastname}`
  }

  /**
   * Crée une instance de DashboardScoreModule à partir de données brutes
   */
  public static create(data: unknown): DashboardScoreModule {
    return EntityValidator.validateAndCreate(
      DashboardScoreModuleSchema,
      data,
      DashboardScoreModule,
      'DashboardScoreModule'
    )
  }
}
